"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_dnd_1 = require("react-dnd");
exports.usePieceDrag = function (props) {
    return react_dnd_1.useDrag({
        item: {
            type: props.board.get(props.position),
            position: props.position
        },
        collect: function (monitor) { return ({ isDragging: monitor.isDragging() }); }
    });
};
exports.default = exports.usePieceDrag;
